module.exports = __webpack_public_path__ + "img/tax3Barcodes@3x.db112efc.png";